export default "__VITE_ASSET__6de171ea__"